import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { masterDataApi } from "../../api/masterData";

export const getMasterData = createAsyncThunk("masterData/getMasterData", async (dataType, { rejectWithValue }) => {
    try {
        const response = await masterDataApi(dataType);
        return { list: response?.body?.data?.master_data_list, listType: dataType };
    } catch (error) {
        console.error({ error });
        return rejectWithValue(error);
    }
});

const masterDataSlice = createSlice({
  name: "masterData",
  initialState: {
    listType: null,
    list: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMasterData.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(getMasterData.fulfilled, (state, action) => {
      state.loading = false;
      state.list = { [action.payload.listType]: action.payload.list, ...state.list };
      state.listType = action.payload.listType;
      state.error = null;
      })
      .addCase(getMasterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default masterDataSlice.reducer;
